import * as firebase from 'firebase/app'
import "firebase/auth";
import { propOr } from 'ramda'

const apiKey = process.env.VUE_APP_FIREBASE_API_KEY
const authDomain = process.env.VUE_APP_FIREBASE_AUTH_DOMAIN
const databaseURL = process.env.VUE_APP_FIREBASE_BASE_URL
const projectId = process.env.VUE_APP_FIREBASE_PROJECT_ID
const storageBucket = process.env.VUE_APP_FIREBASE_STORAGE_BUCKET
const messagingSenderId = process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
const appId = process.env.VUE_APP_FIREBASE_APP_ID
const measurementId = process.env.VUE_APP_FIREBASE_MEASUREMENT_ID

firebase.initializeApp({
  apiKey,
  authDomain,
  databaseURL,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
  measurementId,
});

var facebookProvider = new firebase.auth.FacebookAuthProvider();
facebookProvider.addScope('email');
facebookProvider.setCustomParameters({
    'display': 'popup'
});

export const firebaseAuth = firebase.auth()

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
          unsubscribe();
          resolve(user);
      }, reject);
  })
};

export  function login(elsaUserToken) {
  return firebaseAuth.signInWithCustomToken(elsaUserToken)
    .then(propOr({}, 'user'))
}


export function logout() {
  return firebase.auth().signOut()
}

export function facebookLogin() {
  return firebaseAuth.signInWithPopup(facebookProvider)
    .then(propOr({}, 'user'))
}

export default firebase
